import { render, staticRenderFns } from "./setSchoolTime.vue?vue&type=template&id=de98f322&scoped=true&"
import script from "./setSchoolTime.vue?vue&type=script&lang=js&"
export * from "./setSchoolTime.vue?vue&type=script&lang=js&"
import style0 from "./setSchoolTime.vue?vue&type=style&index=0&id=de98f322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de98f322",
  null
  
)

export default component.exports